export default __webpack_public_path__ + "static/media/Pc2.e236153d.jpg";